import Select from 'react-select';
import { DateTimePicker } from 'react-widgets';
import { isEmpty } from 'lodash';
import classnames from 'classnames';

import { SELECT_STYLES } from 'components/common/Dropdown/DropDownListHelper';
import styles from './ReportReminderForm.scss';
import { DATE_TIME } from 'common/util/dateTime';

export const FREQUENCY_OPTIONS = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Annually', value: 'annually' },
];

const ReportReminderForm = ({
    emailConfig,
    startDate,
    setStartDate,
    startDateErrorMsg,
    frequency,
    setFrequency,
    frequencyErrorMsg,
}) => {
    const groups = !isEmpty(emailConfig.groups) ? emailConfig.groups.join(', ') : '';

    return (
        <div className={styles.emailConfigForm} data-cy="ReportReminderForm">
            <div className={styles.emailConfigForm__userInfo}>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>Email</div>
                    <div className={styles.emailConfigForm__field__value} data-cy="ReportReminderForm-emailAddress">{emailConfig.user.emailAddress}</div>
                </div>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>First Name</div>
                    <div className={styles.emailConfigForm__field__value} data-cy="ReportReminderForm-firstName">{emailConfig.user.firstName}</div>
                </div>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>Last Name</div>
                    <div className={styles.emailConfigForm__field__value} data-cy="ReportReminderForm-lastName">{emailConfig.user.lastName}</div>
                </div>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>Groups</div>
                    <div className={styles.emailConfigForm__field__value} data-cy="ReportReminderForm-groups">{groups}</div>
                </div>
            </div>
            <div className={styles.emailConfigForm__schedule}>
                <h4 data-id="email-config-reminder-title" >Schedule Report Reminder</h4>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>Select Start</div>
                    <div className={styles.emailConfigForm__field__value}>
                        <DateTimePicker
                            className={classnames(styles.DateTimePicker, {
                                [styles.inputError]: startDateErrorMsg,
                            })}
                            autoFocus={false}
                            time={false}
                            placeholder={DATE_TIME.DATE_ONLY_PLACEHOLDER}
                            format={DATE_TIME.DATE_ONLY_FORMAT}
                            value={startDate}
                            onChange={setStartDate}
                        />
                    </div>
                </div>
                <div className={styles.emailConfigForm__field}>
                    <div className={styles.emailConfigForm__field__label}>Frequency</div>
                    <div className={styles.emailConfigForm__field__value} data-cy="ReportReminderForm-Select">
                        <Select
                            className={classnames({
                                [styles.inputError]: frequencyErrorMsg,
                            })}
                            classNamePrefix="frequencySelect"
                            name="frequency"
                            placeholder="Select frequency"
                            options={FREQUENCY_OPTIONS}
                            styles={SELECT_STYLES}
                            value={frequency}
                            onChange={setFrequency}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportReminderForm;
